import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { SupportPage } from '@/routes/_public/faq';

export const Route = createFileRoute('/_authenticated/support/')({
  component: SupportPageWrapper,
  errorComponent: ErrorBoundary,
});

function SupportPageWrapper() {
  return <SupportPage />;
}
